import { render, staticRenderFns } from "./4_PracticeStep.vue?vue&type=template&id=c48e0af0&scoped=true&"
import script from "./4_PracticeStep.vue?vue&type=script&lang=js&"
export * from "./4_PracticeStep.vue?vue&type=script&lang=js&"
import style0 from "./4_PracticeStep.vue?vue&type=style&index=0&id=c48e0af0&lang=scss&scoped=true&"
import style1 from "./4_PracticeStep.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48e0af0",
  null
  
)

export default component.exports